import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import ImportDataModal from 'modals/ImportDataModal';

import { importActions } from 'pages/Settings/ImportExport/ImportLog/ImportLogList';

import PATHS, { mergePaths } from 'utils/paths';

import { faDownload } from '@fortawesome/pro-solid-svg-icons';

const ImportMapping = {
	[mergePaths(PATHS.INVENTORY_MAIN, PATHS.INVENTORY)]: 'inventoryImport',
	[mergePaths(PATHS.INVENTORY_MAIN, PATHS.BIN_INVENTORY)]: 'binInventoryImport',
	[mergePaths(PATHS.INVENTORY_MAIN, PATHS.GLOBAL_INVENTORY)]: 'globalInventoryImport'
};
const HeaderButtons = () => {
	const { pathname } = useLocation();

	return (
		<>
			{ImportMapping[pathname] && (
				<Authorization path={`/import-export/button/${ImportMapping[pathname]}`}>
					<Button
						className="mobile-hidden importDataButton"
						icon={faDownload}
						variant="borderless"
						label="uploadInventory"
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
						onClick={() => NiceModal.show(ImportDataModal, importActions[ImportMapping[pathname]])}
					/>
				</Authorization>
			)}
		</>
	);
};
const Inventory = () => {
	const tabs = useMemo(
		() => [
			{
				label: 'inventory',
				path: mergePaths(PATHS.INVENTORY_MAIN, PATHS.INVENTORY)
			},
			{
				label: 'binInventory',
				path: mergePaths(PATHS.INVENTORY_MAIN, PATHS.BIN_INVENTORY)
			},
			{
				label: 'globalInventory',
				path: mergePaths(PATHS.INVENTORY_MAIN, PATHS.GLOBAL_INVENTORY)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="inventory"
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/Inventory-new.json.gz"
				moduleName="oto-inventory">
				<HeaderButtons />
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default Inventory;
